import CryptoJS from "crypto-js";

const secKey = process.env.REACT_APP_STORE_SECRET_KEY;
export const encryptApiData = (data) => {
  return btoa(`${secKey}${JSON?.stringify(data)}`);
};

export const decryptApiData = (encryptedData) => {
  let rawData = atob(encryptedData);
  let key = rawData.substring(0, 32);
  let finalData;
  try {
    finalData = JSON?.parse(rawData.substring(32, rawData?.length));
  } catch (error) {
    finalData = rawData.substring(32, rawData?.length);
  }
  if (key !== secKey) {
    return "Data may have been tampered";
  }
  return finalData;
};


export const DataEncrypt = (data) => {
  const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_PUBLIC_KEY); // 32 chars = 256 bit
  const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_PUBLIC_KEY_IV); // 16 chars
 
  console.log("key = ",process.env.REACT_APP_ENCRYPT_PUBLIC_KEY);
 
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );
 
  console.log("encrypted =",encrypted.toString());
 
  return encrypted.toString(); // Base64 string
};
 
export const DataDecrypt = (encryptedData) => {
  const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_PUBLIC_KEY); // 32 chars
  const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_PUBLIC_KEY_IV); // 16 chars
 
  const decrypted = CryptoJS.AES.decrypt(
    encryptedData,
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );
 
  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
 
  try {
    return JSON.parse(decryptedText); // if original data was JSON
  } catch (err) {
    return decryptedText; // fallback if not JSON
  }
};
